import { lazy } from 'react';
const PaymentsInvoicesPage = lazy(() => import('../../pages/ConsultasPagosFacturas'));
const ConsultaLiquidacionPageUserLoggedIn = lazy(() =>
  import('../../pages/tramitesonline/consulta-liquidacion'),
);
const ValidarAfiliadoPage = lazy(() => import('../../pages/ValidarAfiliado'));
const DatosPersonalesPage = lazy(() => import('../../pages/datos-personales'));
const TramitesDeAutorizaciones = lazy(() => import('../../pages/tramites-autorizaciones'));
const TramitesConectividadPageLoggedIn = lazy(() => import('../../pages/tramites-conectividad'));
const CapWebPageLoggedIn = lazy(() => import('../../pages/capweb'));
const CalificacionesPage = lazy(() => import('../../pages/Calificaciones'));
const CensusesPage = lazy(() => import('../../pages/censos'));
const RecetaDigitalPage = lazy(() =>
  import('../../pages/tramitesonline/receta-digital/RecetaDigitalPage'),
);
const MedicalAttentionPage = lazy(() => import('../../pages/MedicalAttention'));

const onlineProceduresRoutes = [
  {
    title: 'Consultas de Pagos y Facturas',
    path: 'tramitesonline/consulta-pagos-facturas',
    permission: 'consulta-de-facturas/pagos',
    component: PaymentsInvoicesPage,
    isPrivate: true,
  },
  //{
  //  title: 'Reporte Transaccional',
  //  path: 'tramitesonline/reporte-transaccional',
  //  permission: 'reporte-transaccional',
  //  component: ReporteTransaccionalPage,
  //  isPrivate: true
  //},
  {
    title: 'Consultas de Liquidación',
    path: 'tramitesonline/consulta-de-liquidacion',
    permission: 'consulta-de-liquidacion',
    component: ConsultaLiquidacionPageUserLoggedIn,
    isPrivate: true,
  },
  {
    title: 'Validar Afiliado',
    path: 'tramitesonline/validar-afiliado',
    permission: 'validador-de-asociados',
    component: ValidarAfiliadoPage,
    isPrivate: true,
  },
  {
    title: 'Datos Personales',
    path: 'tramitesonline/datos-personales',
    permission: 'datos-personales',
    component: DatosPersonalesPage,
    isPrivate: true,
  },
  {
    title: 'Trámites de Autorizaciones',
    path: 'tramitesonline/tramites-de-autorizaciones',
    permission: 'tramites-de-autorizaciones',
    component: TramitesDeAutorizaciones,
    isPrivate: true,
  },
  // Esta ruta contempla varias - Ingreseo de prestaciones, busqueda por ticket, reportes y eligibilidad
  {
    title: 'Trámites de Conectividad',
    path: 'tramitesonline/tramites-conectividad',
    permission: 'conectividad',
    component: TramitesConectividadPageLoggedIn,
    isPrivate: true,
  },
  {
    title: 'Centro de Atención a Prestadores',
    path: 'tramitesonline/capweb',
    permission: 'centro-de-atencion-al-prestador',
    component: CapWebPageLoggedIn,
    isPrivate: true,
  },
  {
    title: 'Mis Calificaciones',
    path: 'tramitesonline/mis-calificaciones',
    permission: 'calificaciones',
    component: CalificacionesPage,
    isPrivate: true,
  },
  {
    title: 'Censos',
    path: 'tramitesonline/censos',
    permission: 'censos',
    component: CensusesPage,
    isPrivate: true,
  },
  {
    title: 'Receta Digital',
    path: 'tramitesonline/receta-digital',
    permission: 'receta-digital',
    component: RecetaDigitalPage,
    isPrivate: true,
  },
  {
    title: 'Atención Médica',
    path: 'tramitesonline/atencion-medica',
    permission: 'atencion-medica',
    component: MedicalAttentionPage,
    isPrivate: true,
  },
];

export default onlineProceduresRoutes;
